export default __webpack_public_path__ + "static/media/email.b877e95d.svg";